import { useMatch } from 'react-router-dom';

type ReturnValue = {
  isSharePage: boolean;
};

export const useIsSharePage = (): ReturnValue => {
  const isSharePage = Boolean(useMatch('/magic/p/*'));

  return {
    isSharePage,
  };
};
